<template>
  <nav class="flex flex-start" aria-label="Progress">
    <ol role="list" class="space-y-6">
      <StepWizardItem :status="status(0)">
        Podcast anlegen
      </StepWizardItem>
      <StepWizardItem :status="status(2)">
        Account erstellen
      </StepWizardItem>
    </ol>
  </nav>
</template>

<script setup>
const props = defineProps({step: Number});
const current = (step, alt) => (step == props.step ? 'current' : alt);
const pending = (step, alt) => (step > props.step ? 'pending' : alt);
const status = (s) => current(s, pending(s, 'complete'));
</script>
